import './App.css';
import { MainPage } from './MainPage'
import { OAuthResponse} from './OAuthResponse'
import { Routes, Route } from "react-router-dom";

export function App() {
  return <Routes>
    <Route path="/OAuthResponse" element={<OAuthResponse />} />
    <Route path="/" element={<MainPage />} />
    <Route path="/division/:divisionId/*" element={<MainPage />} />
    <Route path="*" element={<div>Not found (Apps.tsx)</div>} />
  </Routes>
}
